import Graduate from './Models/Graduate'

Vue.prototype.$models.$graduate = new Vue(Graduate)

Vue.component('graduates-table', () => import(/* webpackChunkName: "graduates-table" */ '@modulesPages/Site/Resources/assets/js/Tables/GraduatesTable'))

Vue.component('graduates-form', () => import(/* webpackChunkName: "graduates-form" */ '@modulesPages/Site/Resources/assets/js/Forms/Graduates/GraduatesForm'))

Vue.component('banner-simple', () => import(/* webpackChunkName: "banner-simple" */ '@modulesPages/Site/Resources/assets/js/Components/BannerSimple'))
Vue.component('graduates-import-component', () => import(/* webpackChunkName: "graduates-import-component" */ '@modulesPages/Site/Resources/assets/js/Components/GraduatesImportComponent'))
Vue.component('graduates-export-component', () => import(/* webpackChunkName: "graduates-export-component" */ '@modulesPages/Site/Resources/assets/js/Components/GraduatesExportComponent'))

app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\Site\\Entities\\Graduate': 'Graduado'
    }   
}

app.$Util.tableNameByClassName = {
    ...app.$Util.tableNameByClassName,
    ...{
        'Modules\\Site\\Entities\\Graduate': 'graduates'
    }   
}

app.$Util.classNameByTableName = {
    ...app.$Util.classNameByTableName,
    ...{
        'graduates': 'Modules\\Site\\Entities\\Seaker'
    }   
}
